import constant from "../../constant";
const resource = constant.api + "sales";

// ... existing code ...
const state = {
  cart: {},
  items: [],
  item: {},
  raw_material: {},
};

// getters
const getters = {
  getCart: (state) => {
    return state.cart;
  },
  getItems: (state) => {
    return state.items;
  },

  getItem: (state) => {
    return state.item;
  },

  getTotalPriceTTCItems: (state) =>
    state.items.reduce((acc, val) => {
      const price = parseFloat(
        val.priceTTC || (val.item && val.item.priceTTC) || 0
      );
      const quantity = parseFloat(val.quantity || 0);
      return acc + price * quantity;
    }, 0),

  getTotalQuantityItems: (state) =>
    state.items.reduce((acc, val) => acc + parseFloat(val.quantity), 0),
  getNumberItems: (state) => parseFloat(state.items.length),
};

// actions
const actions = {
  async setItem({ commit }, data) {
    commit("setItem", data);
  },

  async getAll({ commit }) {
    const data = await this._vm.$api.fetch(resource);
    commit("setAll", data);
  },

  async getItems({ commit }) {
    const response = await this._vm.$api.fetch(`${resource}_items`);
    let items = [];
    if (Array.isArray(response)) {
      items = response;
    } else if (response && Array.isArray(response.data)) {
      items = response.data;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
      items = response.data.data;
    }
    commit("setItems", items);
  },

  async destroyItem({ commit, dispatch }, item_reference) {
    const response = await this._vm.$api.delete(
      `${resource}_items/${item_reference}`
    );
    let items = [];
    if (Array.isArray(response)) {
      items = response;
    } else if (response && Array.isArray(response.data)) {
      items = response.data;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
      items = response.data.data;
    }
    commit("setItems", items);

    const message = response?.message || "Item supprimé du panier";
    const status = response?.status || "success";
    dispatch("notification/store", { message, status }, { root: true });
  },

  async addToCart({ commit }, data) {
    return await commit("setItem", data);
  },
};

// mutations
const mutations = {
  async setAll(state, data) {
    return (state.cart = data);
  },

  async setItem(state, data) {
    return (state.item = data);
  },

  async setItems(state, data) {
    console.log("Setting cart items:", data);
    console.log("Is array?", Array.isArray(data));
    state.items = Array.isArray(data) ? data : [];
    console.log("Cart items after set:", state.items);
    return state.items;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
